import { useSections } from "@/contexts/classified";
export const useLocation = () => {
    var _a;
    const location = (_a = useSections()) === null || _a === void 0 ? void 0 : _a.location;
    if (!location)
        return null;
    const { geometry, isAddressPublished, address, transport } = location || {};
    const isGeoPoint = (point) => !!point &&
        Array.isArray(point.coordinates) &&
        point.coordinates.length === 2 &&
        typeof point.coordinates[0] === "number" &&
        typeof point.coordinates[1] === "number";
    const isGeoPolygon = (polygon) => !!polygon && Array.isArray(polygon.coordinates[0]);
    const isGeoDataDefined = (geometry) => {
        if ((geometry === null || geometry === void 0 ? void 0 : geometry.type) === "Point") {
            return isGeoPoint(geometry);
        }
        else if ((geometry === null || geometry === void 0 ? void 0 : geometry.type) === "Polygon" ||
            (geometry === null || geometry === void 0 ? void 0 : geometry.type) === "MultiPolygon") {
            return isGeoPolygon(geometry);
        }
        return false;
    };
    return {
        address,
        isAddressPublished,
        geometry,
        isGeoDataDefined: isGeoDataDefined(geometry),
        transport,
    };
};
